import { Box, CardContent, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CUSTOM_RADII } from "Theme/Shape";
interface ITipsCardContentProps {
  CARD_TITLE: string;
  CARD_DESCRIPTION: string;
  CARD_URL: string;
  IS_STARTING_STEP?: boolean;
}
export const TipsCardContent = (props: ITipsCardContentProps) => {
  const { CARD_TITLE, CARD_DESCRIPTION, CARD_URL, IS_STARTING_STEP } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: isSmallScreen ? "100%" : "450px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Image Container */}
      <Box
        sx={{
          width: "100%",
          aspectRatio: "16 / 10",
          position: "relative",
          borderRadius: CUSTOM_RADII.card,
          overflow: "hidden",
        }}
      >
        <CardMedia
          component="img"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          image={CARD_URL}
          title={CARD_TITLE}
        />
      </Box>

      {/* Text Content */}
      <CardContent
        sx={{
          width: "100%",
          padding: 0,
          mt: 2,
          height: IS_STARTING_STEP ? "auto" : "145px",
          textAlign: "center",
        }}
      >
        <Typography
          id="confirm-dialog-title"
          variant="h6"
          color="textPrimary"
          sx={{
            fontWeight: "fontWeightSemiBold",
            fontSize: isSmallScreen ? "1.25rem" : "1.5rem",
          }}
        >
          {CARD_TITLE}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            pt: 2,
            fontSize: isSmallScreen ? "0.875rem" : "0.95rem",
          }}
        >
          {CARD_DESCRIPTION}
        </Typography>
      </CardContent>
    </Box>
  );
};
